import MicroModal from 'micromodal';
import ApplicationController from '../application_controller';

// Connects to data-controller="landing-pages--modal"
export default class extends ApplicationController {
  connect() {
    super.connect();
    this.show();
  }

  show() { // eslint-disable-line class-methods-use-this
    MicroModal.show('modal-window', {
      disableScroll: true,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
    });
  }
}
